import React from 'react';
import { t, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { ILink } from 'utils/types';

import s from './Documents.module.scss';

type Props = {
  link?: ILink;
  title?: React.ReactNode;
};

export const Item = ({ link, title }: Props) => {
  const { i18n } = useLingui();

  if (!link) {
    return (
      <div className={s.item}>
        <div className={s.item__title}>Document link missing</div>
      </div>
    );
  }

  return (
    <a href={link?.href} className={s.item} download>
      <div className={s.item__title}>{title}</div>
      <div
        className={s.item__icon}
        data-download={`${i18n._(t`Download`)}${
          link?.href?.split('.').pop() === 'pdf' ? ' pdf' : ''
        }`}
      >
        {link?.href?.split('.').pop() === 'pdf' ? (
          <img src="/static/icons/file-pdf.svg" alt="" />
        ) : (
          <img src="/static/icons/file-download.svg" alt="" />
        )}
      </div>
    </a>
  );
};
